import { render } from "./AcceptanceReceiptDetail.vue?vue&type=template&id=cf966ba8&scoped=true"
import script from "./AcceptanceReceiptDetail.vue?vue&type=script&lang=ts"
export * from "./AcceptanceReceiptDetail.vue?vue&type=script&lang=ts"

import "./AcceptanceReceiptDetail.vue?vue&type=style&index=0&id=cf966ba8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cf966ba8"

export default script